module.exports = __webpack_public_path__ + "img/Vector.3db56f3b.svg";